import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-product-content',
    standalone: true,
    imports: [TranslateModule, CommonModule],
    templateUrl: './product-content.component.html',
    styleUrl: './product-content.component.scss'
})
export class ProductContentComponent {
    @Input() isDGP: boolean = false;
}
